<script>
  import { clickOutside } from '../../util/clickOutside.js';
  import { onMount } from 'svelte';
  import 'emoji-picker-element';
  import { External } from '../../../external';

  export let isOpen = false,
    onNewEmoji = () => {};

  const toggle = () => {
    isOpen = !isOpen;
  };

  let container;

  const emojiDatasource = `${External.resources}/emoji/en.json?v=${External.resourcesVersion}`;

  const onEmojiClick = ({ detail }) => {
    onNewEmoji(detail);
    isOpen = false;
  };

  onMount(() => {
    container
      .querySelector('emoji-picker')
      .shadowRoot.querySelector('section.picker')
      .addEventListener('emoji-click', onEmojiClick);
  });
</script>

<div
  style="position: relative;"
  use:clickOutside
  on:click_outside={() => {
    isOpen = false;
  }}>
  <div on:click={toggle} on:keypress={toggle} class="circle-round-btn circle-effect f-left">
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
      <path
        d="M620-520q25 0 42.5-17.5T680-580q0-25-17.5-42.5T620-640q-25 0-42.5 17.5T560-580q0 25 17.5 42.5T620-520Zm-280 0q25 0 42.5-17.5T400-580q0-25-17.5-42.5T340-640q-25 0-42.5 17.5T280-580q0 25 17.5 42.5T340-520Zm140 260q68 0 123.5-38.5T684-400H276q25 63 80.5 101.5T480-260Zm0 180q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Z" />
    </svg>
  </div>
  <div style="position: absolute; z-index: 2; right: 0; top: 30px;" class:none={!isOpen} bind:this={container}>
    <emoji-picker data-source={emojiDatasource} />
  </div>
</div>
